// extracted by mini-css-extract-plugin
export default {"Guide":"ToS_Guide__p8wex","Privacy":"ToS_Privacy__Hln3k","Refund":"ToS_Refund__VWIap","Tos":"ToS_Tos__2yCEy","scrollBox":"ToS_scrollBox__nVrZE"};